export default "__VITE_ASSET__51U_IjbwI0YVanm6PKWK7Q__"